export class Nomnenclatura {
    claveMateria: string;
    nombreMateria: string;
    grupo: number;
    aula: string;
}